<template>
  <div class="row">
    <div class="col-6 col-sm-3 d-flex">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box financial-metric-card radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-calendar-check"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Total de agendamentos
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ getCardsFinancialManagementData.qtd_schedules }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                Mês inteiro
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 col-sm-3 d-flex">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box financial-metric-card radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-money"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Valor total recebido
              </span>
              <h4 class="fw-black mb-8 lh-1">
                R$ {{ getCardsFinancialManagementData.amount_received }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                Total em taxas: <strong>R$ -{{ getCardsFinancialManagementData.tax }}</strong>
              </span>
              <span class="fw-medium text-dark-emphasis">
                Do primeiro ao último dia do mês
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 col-sm-3 d-flex">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box financial-metric-card radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-calendar-x"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Quantidade de despesas
              </span>
              <small class="d-block mb-7 text-muted">Dados gerais da empresa</small>
              <h4 class="fw-black mb-8 lh-1">
                {{ getCardsFinancialManagementData.qtd_expense }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-6 col-sm-3 d-flex">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box financial-metric-card radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="flaticon-money"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Valor total de despesas
              </span>
              <small class="d-block mb-7 text-muted">Dados gerais da empresa</small>
              <h4 class="fw-black mb-8 lh-1">
                R$ {{ getCardsFinancialManagementData.amount_expense }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                Somando do primeiro ao último dia do mês
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "CardsFinancialManagement",
  data() {
    return {};
  },
  methods: {
    convertTime(time: number | string) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  },
  computed:{
    ...mapGetters([
      'getCardsFinancialManagementData'
    ])
  },
});
</script>

<style scoped>
.financial-metric-card {
  flex: 1;
  min-width: 0;
  min-height: 228.5px;
}

.financial-metric-card .title {
  width: 100%;
  min-width: 0;
  overflow-wrap: anywhere;
}

.financial-metric-card h4 {
  line-height: 1.2 !important;
}
</style>
